import { DefaultTheme } from 'styled-components';

import { DARK_COLORS } from './colors';
import { DARK_CONFIG } from './config';

const DARK_THEME: DefaultTheme = Object.freeze({
  borderRadius: '8px',
  config: DARK_CONFIG,
  colors: DARK_COLORS,
  scrollBar: DARK_COLORS.grey.primary,
  transition: {
    default: 'all ease-in-out 0.2s',
  },
  responsive: {
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isTabletUp: false,
  },
});

export { DARK_THEME };
